var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndividual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44 15.62V32.38C44 38 41.42 41.8599 36.88 43.3199C35.56 43.7799 34.04 44 32.38 44H15.62C13.96 44 12.44 43.7799 11.12 43.3199C6.58 41.8599 4 38 4 32.38V15.62C4 8.33999 8.33999 4 15.62 4H32.38C39.66 4 44 8.33999 44 15.62Z",
    fill: "#737A9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8792 43.3199C35.5592 43.7799 34.0392 44 32.3792 44H15.6191C13.9591 44 12.4391 43.7799 11.1191 43.3199C11.8191 38.0399 17.3391 33.9399 23.9991 33.9399C30.6591 33.9399 36.1791 38.0399 36.8792 43.3199Z",
    fill: "#737A9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1599 23.16C31.1599 27.12 27.9598 30.34 23.9998 30.34C20.0398 30.34 16.8398 27.12 16.8398 23.16C16.8398 19.2 20.0398 16 23.9998 16C27.9598 16 31.1599 19.2 31.1599 23.16Z",
    fill: "#737A9D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/Individual.affa8869167673f3e0ad3a80ca7ba878.svg";
export { ForwardRef as ReactComponent };